export default "__VITE_ASSET__dce1197b__"